const Links = {
    BASE_URL: "https://api.foodversy.com/api",
    //BASE_URL: "http://localhost:8080/api",
};

export default Links;
